var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle104(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "415.25826081364033 290.97904624956857 34.57745494169012 37.061891250431415",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M437.72,299.52c-1.13.37-2.06.76-3.04.98-.85.19-1.76.14-2.62.3-4.86.91-7.29,5.43-5.3,10.01,1.4,3.22,3.77,5.53,7.03,6.95,1.7.74,3.13.42,4.5-.67,1.48-1.17,2.13-2.74,2.27-4.59.18-2.41-.48-4.65-1.21-6.89-.27-.83-.64-1.63-.86-2.47-.17-.64.62-1.43,1.32-1.46,1.44-.07,2.61.52,3.43,1.64,5.74,7.87,1.25,18.44-6.54,20.43-.57.14-1.17.34-1.73.28-6.16-.7-11.35-3-14.19-8.95-2.78-5.81-1.56-11.17,2.11-16.1,1.73-2.33,4.24-3.62,7.14-3.93,2.78-.31,5.27.36,7.03,2.72.32.43.4,1.04.66,1.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle104);
export default __webpack_public_path__ + "static/media/twinkle-1-04.6c2f3c3ff590320a26a71d3fe31bb182.svg";
export { ForwardRef as ReactComponent };